export default __webpack_public_path__ + "static/media/icon-cocktail-grey.2154ca08.svg";